const permissionsConfig = require('@configs/permissions.json');

export class Permission {
    id: number;
    name: string;
    code: string;
    read: boolean;
    write: boolean;
    possibleOperations: any = { write: true, read: true, all: true };

    constructor(permission) {
        if (!permission) {
            throw ('Permission isn\'t valorized');
        }
        this.id = permission.id;
        this.read = permission.read === true;
        this.write = permission.write === true;
        this.name = permissionsConfig[this.id];
        // this.name = permission.code;

    }

    getValueForOperation(operationName) {
        if (this.possibleOperations[operationName]) {
            if (operationName === 'all') {
                return this.read && this.write;
            } else {
                return this[operationName];
            }
        }
    }


}